import { render } from "./IconClose.vue?vue&type=template&id=7b2566a4"
import script from "./IconClose.vue?vue&type=script&lang=ts"
export * from "./IconClose.vue?vue&type=script&lang=ts"
script.render = render

export default script